const { icons } = require('./constant');

const fcu = {
	id: 'fcu_master',
	title: 'FCU',
	type: 'collapse',
	icon: icons.IconBranch,
	children: [
		{
			id: 'fcuAgencies',
			title: 'FCU Agencies',
			type: 'item',
			url: '/fcuAgencies',
			icon: icons.AccountBalanceOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'fcuStatuses',
			title: 'FCU Statuses',
			type: 'item',
			url: '/fcuStatuses',
			icon: icons.AccountBalanceOutlinedIcon,
			breadcrumbs: true,
		},
	],
};

export default fcu;
